import { Theme } from "@emotion/react";

import { ICandyTheme } from "./ThemeBuilder/ICandyTheme";

export function theme(props: Theme | { theme: Theme }): ICandyTheme {
    if ("candy" in props) {
        return props.candy;
    }
    return props.theme.candy;
}
